import { Box, Typography } from "@mui/material";
import { CommonStyle, ReusableCTUI } from "Components";
import {
  PatientInitialStateType,
  ScreenInitialStateType,
  UserInitialStateType,
} from "DataTypes/Redux";
import { FC, useEffect } from "react";
import { useSelector } from "react-redux";
import CarePlanApi from "Service/CarePlan.api";
import {
  setFormLoader,
  setRightHead,
  setTimerStatus
} from "Redux/Screen/Action";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import PatientFormatter from "Utils/Patient.Formatter";
import Stages from "Constant/Stages";
import { RouteUrls } from "Constant/RouteUrls";
import { addSelectedPrgm } from "Redux/Patient/Action";
import { CheckBoolean, CheckNumber, CheckStringEmpty } from "Utils/common";

const CareTeam: FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { selectedPrgm }: PatientInitialStateType = useSelector(
    (state: any) => state?.patient
  );
  const { myInfo }: UserInitialStateType = useSelector(
    (state: any) => state?.user
  );
  const isAdmin = myInfo.roleId == 1 || myInfo.roleId == 2
  const {
    rightHead: { timerStatus },
  }: ScreenInitialStateType = useSelector((state: any) => state?.screen);
  const currentStage = selectedPrgm.careplanStage;
  const probStage = PatientFormatter.GetCPStage(Stages.CPProblem);
  const teamStage = PatientFormatter.GetCPStage(Stages.CPTeam);
  const quesStage = PatientFormatter.GetCPStage(Stages.CPQues);
  const recurringStage = PatientFormatter.GetCPStage(Stages.Recurring);
  const editCareTeam =
    (!selectedPrgm.readOnlyArr.some((el) => el == "care-team")) &&
    currentStage > probStage &&
    currentStage < recurringStage &&
    myInfo.id == selectedPrgm.teamInitiatedBy;
  const addProvider =
    (!selectedPrgm.readOnlyArr.some((el) => el == "add-provider")) &&
    currentStage > probStage;
  const editProvider =
    (!selectedPrgm.readOnlyArr.some((el) => el == "edit-provider")) &&
    currentStage > probStage;
  const saveNextBtn = editCareTeam || addProvider || editProvider;
  const nextBtn = !saveNextBtn && (currentStage > teamStage);
  const newRoute =
    selectedPrgm.isCareplanComprehensive ?
      RouteUrls.careSummary :
      RouteUrls.careQuestion;
  const careId = selectedPrgm.careplanId;
  const prgmName = selectedPrgm.abbrevation;

  useEffect(() => {
    handleTimer();
  }, [careId]);

  const handleTimer: () => void = () => {
    if (selectedPrgm.showLogTime) {
      if (timerStatus == 1) {
        dispatch(setTimerStatus({ status: 2, parentApiCall: true }));
      }
      if (prgmName == "RPM") dispatch(setRightHead("care-plan"));
    }
  }

  const handleTeamSaveNext: (data: any) => void = async (data) => {
    const caremanagerId = CheckNumber(data?.caremanagerId);
    const billableproviderId = CheckNumber(data?.billableProviderId);
    const providerId = CheckNumber(data?.teamProviderId);
    const newState = CheckStringEmpty(data?.currentState);
    const hasCareplanQuestionnaireCompleted =
      CheckBoolean(data?.hasCareplanQuestionnaireCompleted);
    selectedPrgm &&
      dispatch(
        addSelectedPrgm({
          ...selectedPrgm,
          caremanagerId,
          billableproviderId,
          providerId,
          careplanState: newState,
          careplanStage: PatientFormatter.GetCPStage(newState),
          hasCareplanQuestionnaireCompleted: hasCareplanQuestionnaireCompleted,
        })
      );
    dispatch(setFormLoader(false));
    navigate(`../${newRoute}`, { replace: true });
  };

  const handleNext: () => void = async () => {
    if (selectedPrgm.careplanStage < quesStage) {
      const res = await CarePlanApi.CPStateUpdate({
        data: { toState: Stages.CPQues },
        id1: careId,
      });
      if (res?.success) {
        dispatch(
          addSelectedPrgm({
            ...selectedPrgm,
            careplanState: Stages.CPQues,
            careplanStage: quesStage,
          })
        );
      }
    }
    navigate(`../${newRoute}`, { replace: true });
  };

  return (
    <Box width="91%" sx={{ overflow: "auto", ...CommonStyle.sxWhiteCard }}>
      <Typography variant="body2" fontWeight="bold">
        Enrolled Program - {prgmName}
      </Typography>
      <ReusableCTUI
        addAddProviders={addProvider}
        displayNextBtn={nextBtn}
        displaySaveBtn={false}
        displaySaveNextBtn={saveNextBtn}
        editAddProviders={editProvider}
        editCareTeam={editCareTeam}
        filterForm1EmptyFields={false}
        filterForm2EmptyFields={false}
        openAllForSA={isAdmin}
        prgmDetails={selectedPrgm}
        handleNext={handleNext}
        handleSaveNext={handleTeamSaveNext}
      />
    </Box>
  );
};
export default CareTeam;
